import React, { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
var scholarshipPageContext = /*#__PURE__*/createContext(undefined);
export function ScholarshipPageContextProvider(_ref) {
  var scholarship = _ref.scholarship,
    children = _ref.children;
  var value = useMemo(function () {
    return {
      scholarship: scholarship
    };
  }, [scholarship]);
  return _jsx(scholarshipPageContext.Provider, {
    value: value,
    children: children
  });
}
export function useScholarshipPageContext() {
  var value = useContext(scholarshipPageContext);
  if (value === undefined) {
    throw new Error('useScholarshipPageContext must be used within a ScholarshipPageContextProvider');
  }
  return value;
}